function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { SearchQuery, buildFilterSummary } from '@domain-group/fe-allhomes-search-api';
import { NotificationIcon, NotificationOnIcon } from '@domain-group/fe-co-icon';
import SignInType from '@domain-group/fe-allhomes-library/lib/enums/sign-in-type';
import { storageFactory } from '@domain-group/fe-helper';
import propertyAlertWrapper from './wrapper';
import OnboardingPopup from './onboarding-popup';
import ActionPopup from './action-popup';
import * as styles from './property-alert-button.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class PropertyAlertButton extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "updateButtonState", () => {
      this.setState({
        alertId: this.props.alertId,
        filterSummary: this.props.filterSummary
      });
    });
    _defineProperty(this, "handleAlertClicked", event => {
      event.preventDefault();
      event.stopPropagation();
      if (!this.props.isIdentityLoaded) {
        return;
      }
      this.props.onAlertClick();
      this.startPopupFlow();
    });
    _defineProperty(this, "startPopupFlow", () => {
      if (this.state.firstTimeUser) {
        this.setState({
          promoPopup: true,
          firstTimeUser: false
        });
        this.storage.setItem('firstTimeUser', false);
        this.storage.setItem('displayPromo', false);
      } else if (this.props.isSignedIn) {
        this.setState({
          displayActionPopup: true
        });
      } else {
        this.props.openSignIn(SignInType.PROPERTY_ALERT).then(success => {
          if (success) {
            this.displayPopup();
          }
        });
      }
    });
    _defineProperty(this, "displayPopup", () => {
      this.setState({
        displayActionPopup: true
      });
    });
    _defineProperty(this, "handleOnboadingContinue", () => {
      this.closeOnboardingPopup();
      this.startPopupFlow();
    });
    _defineProperty(this, "closeOnboardingPopup", () => this.setState({
      promoPopup: false,
      displayPromo: false
    }));
    _defineProperty(this, "closeActionPopup", () => this.setState({
      displayActionPopup: false,
      showCreateConfirmation: false
    }));
    _defineProperty(this, "createPropertyAlert", frequency => {
      var alert = {
        id: this.state.alertId,
        listingType: this.props.listingType,
        query: this.props.query,
        name: this.props.alertName,
        frequency: frequency.toUpperCase()
      };
      this.props.createPropertyAlert(alert).then(result => {
        this.props.onCreateAlert(result);
        this.setState({
          showCreateConfirmation: true,
          alertId: result.id,
          filterSummary: buildFilterSummary(new SearchQuery(this.props.listingType, result.query))
        });
      });
    });
    _defineProperty(this, "removePropertyAlert", () => {
      this.props.onRemoveAlert();
      this.props.removePropertyAlert(this.state.alertId).then(() => {
        this.setState({
          alertId: null
        });
        this.closeActionPopup();
        this.props.deleteConfirmation();
      });
    });
    _defineProperty(this, "editPropertyAlert", () => {
      this.props.onEditAlert();
      if (typeof window !== 'undefined') {
        window.location.href = this.props.editAlertUrl + this.state.alertId;
      }
    });
    _defineProperty(this, "managePropertyAlerts", () => {
      this.props.onManageAlert();
      if (typeof window !== 'undefined') {
        window.location.href = this.props.manageAlertUrl;
      }
    });
    this.storage = storageFactory({
      name: 'alert',
      driver: storageFactory.LOCALSTORAGE
    });
    this.state = {
      promoPopup: false,
      displayActionPopup: false,
      showCreateConfirmation: false,
      firstTimeUser: this.storage.getItem('firstTimeUser') === null,
      displayPromo: this.storage.getItem('displayPromo') === null,
      alertId: null,
      filterSummary: ''
    };
  }
  componentDidMount() {
    if (this.props.alertId) {
      this.updateButtonState();
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.alertId !== prevProps.alertId && this.props.alertId !== this.state.alertId) {
      this.updateButtonState();
    }
  }
  render() {
    var alertId = this.state.alertId;
    var isIdentityLoaded = this.props.isIdentityLoaded;
    var BellIcon = alertId ? NotificationOnIcon : NotificationIcon;
    return ___EmotionJSX("div", {
      css: styles.container
    }, ___EmotionJSX("button", {
      "aria-label": "Property alert",
      css: styles.alertButton({
        alertId,
        isIdentityLoaded
      }),
      onClick: this.handleAlertClicked,
      type: "button"
    }, ___EmotionJSX(BellIcon, {
      css: styles.bellIcon,
      size: "regular"
    }), ___EmotionJSX("span", {
      css: styles.buttonLabel
    })), this.state.promoPopup && this.state.displayPromo && ___EmotionJSX(OnboardingPopup, {
      onClose: this.closeOnboardingPopup,
      displayCreatePopup: this.handleOnboadingContinue,
      createPropertyAlert: this.createPropertyAlert,
      editPropertyAlert: this.editPropertyAlert,
      removePropertyAlert: this.removePropertyAlert,
      managePropertyAlerts: this.managePropertyAlerts,
      showCreateConfirmation: this.state.showCreateConfirmation,
      alertId: this.state.alertId
    }), this.state.displayActionPopup && !this.state.displayPromo && ___EmotionJSX(ActionPopup, {
      onClose: this.closeActionPopup,
      createPropertyAlert: this.createPropertyAlert,
      editPropertyAlert: this.editPropertyAlert,
      removePropertyAlert: this.removePropertyAlert,
      managePropertyAlerts: this.managePropertyAlerts,
      showCreateConfirmation: this.state.showCreateConfirmation,
      alertId: this.state.alertId,
      alertName: this.props.alertName,
      filterSummary: this.state.filterSummary,
      searchQuery: this.props.query,
      earlyAccessEnabled: this.props.earlyAccessEnabled
    }));
  }
}
PropertyAlertButton.propTypes = {
  isSignedIn: PropTypes.bool,
  openSignIn: PropTypes.func,
  alertName: PropTypes.string.isRequired,
  listingType: PropTypes.string.isRequired,
  query: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  createPropertyAlert: PropTypes.func,
  removePropertyAlert: PropTypes.func,
  deleteConfirmation: PropTypes.func,
  editAlertUrl: PropTypes.string.isRequired,
  manageAlertUrl: PropTypes.string.isRequired,
  onAlertClick: PropTypes.func,
  onCreateAlert: PropTypes.func,
  onManageAlert: PropTypes.func,
  onEditAlert: PropTypes.func,
  onRemoveAlert: PropTypes.func,
  alertId: PropTypes.number,
  filterSummary: PropTypes.string,
  isIdentityLoaded: PropTypes.bool,
  earlyAccessEnabled: PropTypes.bool
};
PropertyAlertButton.defaultProps = {
  isSignedIn: false,
  openSignIn: () => Promise.resolve(false),
  createPropertyAlert: () => {},
  removePropertyAlert: () => {},
  deleteConfirmation: () => {},
  query: null,
  onAlertClick: () => {},
  onCreateAlert: () => {},
  onManageAlert: () => {},
  onEditAlert: () => {},
  onRemoveAlert: () => {},
  alertId: null,
  filterSummary: '',
  isIdentityLoaded: false,
  earlyAccessEnabled: false
};
export default propertyAlertWrapper(PropertyAlertButton);
export { PropertyAlertButton as BasePropertyAlertButton };